/**
 * @generated SignedSource<<e40d4f24c9830e491b2fec57ac8faf61>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type ActiveRecords = "ACTIVE" | "BOTH" | "INACTIVE" | "%future added value";
export type SitesFilterInput = {
  isActive?: ActiveRecords | null | undefined;
  schoolYearEndsBeforeOrOn?: any | null | undefined;
  siteIds?: ReadonlyArray<string> | null | undefined;
  userId?: string | null | undefined;
};
export type ClassesAllSitesQuery$variables = {
  input?: SitesFilterInput | null | undefined;
};
export type ClassesAllSitesQuery$data = {
  readonly sites: {
    readonly nodes: ReadonlyArray<{
      readonly id: string;
      readonly name: string | null | undefined;
      readonly targetGroups: ReadonlyArray<{
        readonly id: string;
        readonly name: string | null | undefined;
      } | null | undefined> | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
};
export type ClassesAllSitesQuery = {
  response: ClassesAllSitesQuery$data;
  variables: ClassesAllSitesQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v3 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Literal",
        "name": "first",
        "value": 100
      },
      {
        "kind": "Variable",
        "name": "sitesFilterInput",
        "variableName": "input"
      }
    ],
    "concreteType": "SiteNodeConnection",
    "kind": "LinkedField",
    "name": "sites",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "SiteNode",
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "TargetGroupNode",
            "kind": "LinkedField",
            "name": "targetGroups",
            "plural": true,
            "selections": [
              (v1/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ClassesAllSitesQuery",
    "selections": (v3/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ClassesAllSitesQuery",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "9340f6da99a594e1327a4b3cc9c2193a",
    "id": null,
    "metadata": {},
    "name": "ClassesAllSitesQuery",
    "operationKind": "query",
    "text": "query ClassesAllSitesQuery(\n  $input: SitesFilterInput\n) {\n  sites(sitesFilterInput: $input, first: 100) {\n    nodes {\n      id\n      name\n      targetGroups {\n        id\n        name\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "01c0992e8ab0f6be2ceb8ca1ffd597c2";

export default node;
